import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Tabs, Tab } from '@mui/material';
import { useSelector } from 'react-redux';
import { get as lodashGet } from 'lodash';

import logo from 'src/assets/logo_white.png';
import { getCouponList } from 'src/actions/coupon';
import { useActions } from 'src/hooks/useActions';
import { useAuth } from 'src/providers/Auth';
import AvailableCouponList from './AvailableCouponList';
import ChangedCouponList from './ChangedCouponList';
import KvImageList from './KvImageList';

const Wrapper = styled.div`
  background: #fff;
  .coupon-header {
    padding: 22px;
    background-color: #7b7c7e;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .MuiTab-root {
    background-color: #ebebeb;
    font-size: 24px;
    letter-spacing: 4px;
  }
  .Mui-selected,
  .MuiTabs-indicator {
    font-weight: normal;
    background-color: #fff;
    font-size: 24px;
    letter-spacing: 4px;
  }
  .MuiTab-root {
  }
  .tabs-wrapper {
    margin-top: -5px;
  }
`;

const couponTabPanel = (props) => [
  <AvailableCouponList {...props} />,
  <ChangedCouponList {...props} />,
];

const CouponList = (props) => {
  const { setIsLoading } = props;
  const {
    auth: { userId },
  } = useAuth();
  const [tabIndex, setTabIndex] = useState(0);
  const [actionGetCouponList] = useActions([getCouponList]);
  const exchangedRaw = useSelector((state) => state.ajax.exchangedCoupon) || [];
  const exchangedCoupons = lodashGet(exchangedRaw, ["data", "rows"], []);

  useEffect(() => {
    async function init() {
      setIsLoading(true);
      await Promise.all([
        actionGetCouponList({ isExchanged: true, userId }),
        actionGetCouponList({ isExchanged: false, userId }),
      ]);
      setIsLoading(false);
    }
    init();
  }, [userId]);

  return (
    <Wrapper>
      <div className="coupon-header">
        <img alt="logo" src={logo} width="30%" />
      </div>

      <KvImageList />

      <div className="tabs-wrapper">
        <Tabs
          value={tabIndex}
          onChange={(e, newValue) => setTabIndex(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          centered
        >
          <Tab
            id="tab-coupons"
            aria-controls="tabpanel-coupons"
            label="未兌換"
          />
          <Tab
            disabled={!exchangedCoupons.length}
            id="tab-changed-coupons"
            aria-controls="tabpanel-changed-coupons"
            label="已兌換"
          />
        </Tabs>
        {couponTabPanel(props)[tabIndex]}
      </div>
    </Wrapper>
  );
};

export default CouponList;
